import React from 'react'
import ProductCard from '../ProductCard'
import denchair from '../../assets/denchair.jpeg'
import pecker from '../../assets/pecker.jpeg'
import zen from '../../assets/zen.jpeg'
import retianers from '../../assets/retainers.webp'
import gi from '../../assets/gi.jpeg'
import hand from '../../assets/hand.webp'

    const data = [
        {
            id: 1,
            name: 'Dental Chair',
            imgSrc: denchair,
        },
        {
            id: 2,
            name: 'Woodpecker curing light',
            imgSrc: pecker,
        },
        {
            id: 3,
            name: 'Zirconium / porcelain bridges & crowns',
            imgSrc: zen,
        },
        {
            id: 4,
            name: 'Clear Aligner Retainers/ Dental Appliances',
            imgSrc: retianers,
        },
        {
            id: 5,
            name: 'Dental composite material',
            imgSrc: gi,
        },
        {
            id: 6,
            name: 'Dental Hand Instruments',
            imgSrc: hand,
        },
    ]

export default function Card2() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {data.map((item, index) => (
                <ProductCard key={item.id} product={item} index={index} />
            ))}
        </div>
    )
}
